import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { SharedModule } from '../../../shared/shared.module';
import { DpRubricasComponent } from './dp-rubricas.component';
import { DpDescobrirRubricasComponent } from './dp-descobrir-rubricas.component';

@NgModule({
  declarations: [DpRubricasComponent, DpDescobrirRubricasComponent],
  exports: [DpRubricasComponent],
  imports: [CommonModule, FormsModule, PoModule, SharedModule]
})
export class DpRubricasModule {}
